<template>
  <div class="telzxdet">
    <telzxdetmenu />
    <div class="w12 between">
      <div class="lefcol">
        <huadoswip />
        <telzxhpls class="mt30" />
        <teldetyhpj class="mt50" />
      </div>
      <div class="rigcol">
        <!-- <div class="ys"></div> -->

        <div class="lately mt30">
          <sub-title text="最近服务记录" />
          <div class="tel_timeline">
            <lat-ser-timeline :spl="16" />
          </div>
        </div>

        <div class="dhzxjq mt30">
          <sub-title text="电话咨询技巧" />
          <div class="jq_list mt30">
            <div class="jq_item flex">
              <div class="sort">1</div>
              <div class="nr">请先想好问题的具体内容</div>
            </div>

            <div class="jq_item flex">
              <div class="sort">2</div>
              <div class="nr">根据您的问题寻找合适的律师</div>
            </div>

            <div class="jq_item flex">
              <div class="sort">3</div>
              <div class="nr">建议拨打时间 9:00~21:00</div>
            </div>
          </div>
        </div>

        <div class="lkzx mt30">
          <div class="btn">立即咨询</div>
        </div>
      </div>
    </div>

    <section class="w_fluid"><teladv /></section>


  </div>
</template>

<script>
import telzxdetmenu from "./child/telzxdetmenu";
import huadoswip from "./child/huadoswip";
import telzxhpls from "./child/telzxhpls";
import teldetyhpj from "./child/teldetyhpj";
import latSerTimeline from "views/telzx/components/lat_ser_timeline";
import subTitle from "views/home/components/subTitle";
import teladv from "views/telzx/child/teladv"; //评价咨询
export default {
  components: {
    telzxdetmenu,
    huadoswip,
    telzxhpls,
    teldetyhpj,
    subTitle,
    latSerTimeline,
    teladv,
  },
};
</script>

<style lang="scss" scoped>
.telzxdet {
  background-color: #fff;
  padding: 50px 0 0;
  .w12 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    align-items: flex-start;
    .bgff {
      box-shadow: 0px 2px 8px 0px rgba(1, 1, 1, 0.07);
    }
    .lefcol {
      width: 830px;
    }
    .rigcol {
      width: 340px;
      .ys {
        width: 100%;
        height: 180px;
        background-image: url("~assets/entrust/tdycbg2.png");
      }
      .lately {
        width: 100%;
        padding: 18px 15px;
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
        .tel_timeline {
          margin-top: 30px;
        }
      }
      .dhzxjq {
        width: 100%;
        .jq_list {
          .jq_item {
            width: 100%;
            height: 57px;
            margin-top: 12px;
            line-height: 57px;
            color: #fff;
            background: url("~assets/telzx/zxjq_bg.png");
            .sort {
              width: 52px;
              height: 57px;
              text-align: center;
              font-size: 24px;
              color: #0465ea;
              background-color: #edf5ff;
            }
            .nr {
              padding-left: 30px;
            }
          }
        }
      }

      .lkzx {
        width: 100%;
        height: 388px;
        background: url("~assets/telzx/likezx_bg.png") no-repeat;
        padding-top: 240px;
        .btn {
          cursor: pointer;
          width: 100px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          margin: 0 auto;
          background: #ff7e00;
          border-radius: 5px;
          font-size: 18px;
          color: #ffffff;
        }
      }
    }
  }
  .w_fluid {
    width: 100%;
  }
}
</style>